import { Module } from '../modules/module';
import { TypeModule } from '../../enums/type-module';
import { Image } from '../image';
import { NameModule } from '../name-module';

export class ModuleGallery extends Module {
    gallerys: Array<Image>;
    selected: boolean;
    access_groups: any
    typeVision: number;
    typeOrder: string;
    visOnlyForLoggedUser: boolean;

    constructor(name: NameModule, icon: string, eventId: string, typeVision: number, order: number, visOnlyForLoggedUser?: boolean) {
        super(name, icon, TypeModule.GALLERY, eventId, order, true, true, true);
        this.gallerys = [];
        this.selected = true;
        this.access_groups = {};
        this.typeVision = typeVision;
        this.typeOrder = 'recent';
        if (visOnlyForLoggedUser === undefined) {
            this.visOnlyForLoggedUser = false;
        } else {
            this.visOnlyForLoggedUser = visOnlyForLoggedUser;
        }
    }
}
